// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.68 6.56C7.06 6.17 7.59 5.92 8.17 5.92C9.32 5.92 10.25 6.85 10.25 8C10.25 8.59 10 9.12 9.61 9.49',
  'M2.75 6.39L1.95 7.27C1.58 7.68 1.58 8.32 1.95 8.73L4.38 11.4C5.72 12.76 7.57 13.25 9.28 12.88M6.82 3.18C8.59 2.7 10.55 3.18 11.97 4.6L14.39 7.27C14.76 7.68 14.76 8.32 14.39 8.73L13.41 9.81',
  'M2 2L14 14',
];
